import { render, staticRenderFns } from "./FormAttendance.vue?vue&type=template&id=bef12e86"
import script from "./FormAttendance.vue?vue&type=script&lang=js"
export * from "./FormAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports